import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

/**
 * Liten banner som vises øverst på sider hvor selve innholdet
 * fortsatt er delvis på norsk. Skjules helt på norsk språkvalg.
 */
export default function TranslationProgressBanner() {
  const { t, i18n } = useTranslation();
  if (i18n.language === "no") return null;
  return (
    <div
      className="mb-8 border-l-2 border-[var(--gold)] bg-[var(--gold)]/[0.06] px-4 py-3 flex items-start gap-3"
      data-testid="translation-progress-banner"
    >
      <Languages className="h-4 w-4 text-[var(--gold)] shrink-0 mt-0.5" />
      <p className="font-manrope text-xs text-[var(--cream-soft)] leading-relaxed">
        {t(
          "common.translation_progress",
          "This page is being translated. Some details may still appear in Norwegian."
        )}
      </p>
    </div>
  );
}
